import { render, staticRenderFns } from "./PolicySVG.vue?vue&type=template&id=0b7b0069&scoped=true"
import script from "./PolicySVG.vue?vue&type=script&lang=js"
export * from "./PolicySVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b0069",
  null
  
)

export default component.exports